<template>
  <div class="mx-auto w-36 text-center text-xl">
    <i
      aria-hidden="true"
      class="fad fa-circle-notch fa-spin" />
  </div>
</template>
